module.exports = __webpack_public_path__ + "img/icon-recipe.2a9d063d.svg";